module.exports = __webpack_public_path__ + "img/1.109c53ee.jpg";